import React from 'react'
import Skeleton from 'react-loading-skeleton'
import { GalleryContainer } from '../../pages/productDetailPage/ProductDetailsPage.style'

const ProductImageGallerySkeleton = () => {
  return (
    <div className="relative">
      {/* Discount badge skeleton */}
      <div className="absolute top-5 left-5 z-10">
        <Skeleton
          width={140}
          height={32}
          baseColor="#f1f5f9"
          highlightColor="#e2e8f0"
          className="!rounded-full"
        />
      </div>

      {/* Product tag skeleton */}
      <div className="absolute top-5 right-5 z-10">
        <Skeleton
          width={32}
          height={32}
          baseColor="#f1f5f9"
          highlightColor="#e2e8f0"
          className="!rounded-full"
        />
      </div>

      <GalleryContainer>
        {/* Main image skeleton */}
        <div className="relative mb-4">
          <Skeleton
            height={384}
            baseColor="#f8fafc"
            highlightColor="#e2e8f0"
            className="!rounded-2xl"
          />
        </div>

        {/* Thumbnail images skeleton */}
        <div className="flex gap-3 justify-center">
          {Array(4)
            .fill()
            .map((_, index) => (
              <Skeleton
                key={index}
                width={80}
                height={80}
                baseColor="#f1f5f9"
                highlightColor="#e2e8f0"
                className="!rounded-lg"
              />
            ))}
        </div>
      </GalleryContainer>
    </div>
  )
}

export default ProductImageGallerySkeleton
